export default __webpack_public_path__ + "static/media/welcome.3cefb4ba.svg";